import { render, staticRenderFns } from "./KtbFastPay.vue?vue&type=template&id=606ff6e1&scoped=true"
import script from "./KtbFastPay.vue?vue&type=script&lang=js"
export * from "./KtbFastPay.vue?vue&type=script&lang=js"
import style0 from "./KtbFastPay.vue?vue&type=style&index=0&id=606ff6e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606ff6e1",
  null
  
)

export default component.exports